import React from "react";
import "./SignPdfReviewPopdown.css";

/**
 * Review step actions on the progress rail.
 */
const SignPdfReviewPopdown = ({
  disabled = false,
  onCompleted = () => {},
}) => (
  <div className="sp-review-popdown" role="menu">
    <p className="sp-review-popdown__title">Review</p>
    <p className="sp-review-popdown__hint">
      Complete review and press Finish to download / share / print your document.
    </p>
    <div className="sp-review-popdown__actions">
      <button
        type="button"
        className="sp-review-popdown__btn sp-review-popdown__btn--success"
        disabled={disabled}
        onClick={onCompleted}
      >
        Completed
      </button>
    </div>
  </div>
);

export default SignPdfReviewPopdown;
